import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TrustiiService} from 'src/app/services/trustii.service';

@Component({
  selector: 'app-invite-member-dialog',
  templateUrl: './invite-member.dialog.html',
  styleUrls: ['./invite-member.dialog.scss']
})
export class InviteMemberDialogComponent {
  public teamId: number;
  public datasetId: number;
  public name: string;
  inProgress = false;
  isReady = false;
  teams = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { datasetId: number },
    private dialogRef: MatDialogRef<InviteMemberDialogComponent>,
    private trustiiService: TrustiiService
  ) {
    this.datasetId = data.datasetId;
    this.trustiiService.datasetTeamsMember(this.datasetId).subscribe(
      (res) => {
        this.teams = res.data;
        this.isReady = true;
      },
      (err) => {
        this.isReady = true;
      }
    );
  }

  invite() {
    this.inProgress = true;
    const data = {
      teamId: this.teamId
    };
    this.trustiiService.inviteTeamMember(data, this.datasetId).subscribe(
      (res) => {
        this.dialogRef.close({data: 'confirmation'});
      },
      (err) => {
        this.inProgress = false;
      }
    );
  }
}
